/** IDs por tipo (misma fuente para formularios, DscItem y glosas) */
export const MORTALITY_RESIDUE_IDS = {
	ENSILADA: '667b4261c0984a8a04087bf2',
	PECES_ENTEROS: '667b4261c0984a8a04087bf3',
	VISCERAS: '69bb09e9e77b4cbff620c206',
};

// IDs de todos los residuos de mortalidad
const MORTALITY_RESIDUES = [
	MORTALITY_RESIDUE_IDS.ENSILADA,
	MORTALITY_RESIDUE_IDS.PECES_ENTEROS,
	MORTALITY_RESIDUE_IDS.VISCERAS,
];

const CURRENCY_LABELS = {
	USD: 'DOLAR',
	EUR: 'EURO',
	UF: 'UF',
	GBP: 'LIBRA ESTERLINA',
};

function formatDateDMY(dateStr) {
	if (!dateStr) return '';
	// Maneja tanto '2026-03-20' como '2026-03-20T00:00:00'
	const datePart = dateStr.split('T')[0];
	const [y, m, d] = datePart.split('-');
	return `${d}/${m}/${y}`;
}

/**
 * Construye la línea de tasa de cambio para observaciones.
 * Ej: "VALOR DOLAR USADO: $921 CLP DEL 26/03/2026"
 */
function buildExchangeRateNote(items) {
	const seen = new Set();
	const lines = [];

	for (const item of items || []) {
		const mv = item._module_vars;
		if (!mv?.es_valorizable || !mv.moneda || mv.moneda === 'CLP') continue;
		if (!mv.conversion_rate) continue;

		const key = `${mv.moneda}_${mv.conversion_rate}_${mv.conversion_rate_date}`;
		if (seen.has(key)) continue;
		seen.add(key);

		const label = CURRENCY_LABELS[mv.moneda] || mv.moneda;
		const rateStr = Number.isInteger(mv.conversion_rate)
			? mv.conversion_rate
			: mv.conversion_rate.toFixed(2);
		const dateStr = formatDateDMY(mv.conversion_rate_date);
		lines.push(
			`VALOR ${label} USADO: $${rateStr} CLP DEL ${dateStr}`,
		);
	}

	return lines.join('\n');
}

/**
 * Bloque automático de observaciones para guías de residuos.
 * Incluye glosa de precio referencial + tasa de cambio usada cuando hay items valorizables.
 * Las glosas de ORIGEN/DESTINO, tipo de traslado y NO APTO se movieron al DscItem de cada ítem.
 */

function buildGuiasOrigenBlock(values) {
	if (values?.residuos_operation_type !== 'envio_bodega_no_peligrosos') {
		return '';
	}
	const folios = new Set();
	for (const item of values.items || []) {
		const mv = item._module_vars;
		if (!mv?._is_warehouse_guide_lines_send) continue;
		for (const folio of mv.source_guide_folios || []) {
			const f = String(folio || '').trim();
			if (f) folios.add(f);
		}
	}
	if (folios.size === 0) return '';
	return `GUIAS ORIGEN: ${[...folios].join(', ')}`;
}

export function buildResiduosObservacionesAutoBlock(values) {
	if (!values || values.guide_category !== 'residuos') {
		return '';
	}

	const parts = [];

	const guiasOrigen = buildGuiasOrigenBlock(values);
	if (guiasOrigen) {
		parts.push(guiasOrigen);
	}

	const hasValorizable = (values.items || []).some(
		item => item._module_vars?.es_valorizable,
	);

	if (!hasValorizable) {
		return parts.join('\n');
	}

	// Primero: tasa de cambio (si aplica)
	const rateNote = buildExchangeRateNote(values.items);
	if (rateNote) {
		parts.push(rateNote);
	}

	// Luego: glosa de precio referencial
	parts.push(
		'EL PRECIO INDICADO EN ESTE DOCUMENTO ES REFERENCIAL EL QUE ESTÁ SUJETO A CONFIRMACIÓN Y LA CANTIDAD DE KILOS ES ESTIMADO YA QUE ESTÁ SUJETO A LOS KILOS RECEPCIONADOS',
	);

	return parts.join('\n');
}

// Exportar MORTALITY_RESIDUES para usarlo en otros módulos
export { MORTALITY_RESIDUES };

/**
 * Observaciones finales para DTE y backend: bloque automático (residuos) + texto libre del usuario.
 */
export function mergeObservacionesGuiaForPayload(values) {
	const user = (values?.observaciones_guia || '').trim();
	const auto = buildResiduosObservacionesAutoBlock(values);
	if (!auto) {
		return user;
	}
	if (!user) {
		return auto;
	}
	return `${auto}\n\n${user}`;
}
